export default "__VITE_ASSET__B$Wuxfru__"